import React, { useEffect} from 'react'
import {
  Grid,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import VideoCard from './VideoCard'
import { URL} from '../config'

const VideoPanel = ({ videos, setVideos }) => {

  const fetchVideos = async () => {
    const url = URL+`/v1/videos`;
    const response = await fetch(url);
    const data = await response.json();
    setVideos(data.videos);
  }

  useEffect(() => {
    fetchVideos();
  },[])

  return (
    <Grid container spacing={2} padding={5}>
      {videos ? (
        videos.map((video) => (
          <Grid item xl={3} lg={4} md={6} sm={12} key={`video-${video._id}`}>
            <VideoCard video={video}/>
          </Grid>
        ))
      ) : (
        <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Grid>
  )
}

export default VideoPanel